<template>
  <div>
    <b-card>
      <b-form>
        <label v-if="1 !== 1" class="m-2" for="inline-form-input-name">Тип</label>
        <b-form-select
          v-if="1 !== 1"
          v-model="model.type"
          :options="[
            { value: 1, text: 'Примечание' },
            { value: 2, text: 'Задание' },
          ]"
        ></b-form-select>
        <label class="m-2" for="inline-form-input-name">Текст записи</label>
        <b-form-textarea
          class="m-2"
          v-model="model.text"
          id="inline-form-input-name"
          placeholder="Текст"
        ></b-form-textarea>
        <span v-if="model.type == 2">
          <label class="m-2" for="inline-form-input-username">Срок выполнения</label>
          <b-form-datepicker class="m-2" id="example-datepicker" v-model="model.deadline"></b-form-datepicker>
          <b-form-checkbox :value="1" :unchecked-value="0" class="m-2" v-model="model.remind"
            >Напомнить</b-form-checkbox
          >
          <label class="m-2" v-if="model.remind == 1" for="inline-form-input-username">Когда напомнить</label>
          <b-form-datepicker
            v-if="model.remind == 1"
            class="m-2"
            id="example-datepicker2"
            v-model="model.remind_at"
          ></b-form-datepicker>
          <label class="m-2" v-if="model.remind == 1" for="inline-form-input-name">Текст напоминания</label>
          <b-form-textarea
            v-if="model.remind == 1"
            v-model="model.remind_text"
            id="inline-form-input-name"
            placeholder="Текст напоминания"
            class="m-2"
          ></b-form-textarea>
        </span>
        <b-button variant="primary" @click="postTask()" class="m-2">Добавить</b-button>
      </b-form>
      <hr />
      <b-list-group>
        <b-list-group-item v-for="task in tasks" :key="task.created_at">
          <div v-if="model.type == 1">
            <b>{{ getModerator(task.manager_id) }}</b>
            {{ parseInt(task.created_at) | moment("timezone", $moment.tz.guess(), "lll") }} - <b>{{ task.text }}</b
            >.
          </div>
          <div v-else>
            {{ parseInt(task.created_at) | moment("timezone", $moment.tz.guess(), "lll") }} - <b>{{ task.text }}</b
            >. Дедлайн - {{ parseInt(task.deadline) | moment("timezone", $moment.tz.guess(), "ll") }}
            <h4 style="display: inline" class="ml-3">
              <b-badge v-if="model.status == 0">Создано</b-badge>
              <b-badge v-if="model.status == 1" variant="success">Завершено</b-badge>
            </h4>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Risk",
  props: {
    tasks: Array,
    user_id: Number,
    moderators: Array,
  },
  data() {
    return {
      initModel: {
        type: 1,
        status: 0,
        text: null,
        remind: 0,
        remind_at: null,
        remind_text: null,
        deadline: null,
      },
      model: {
        type: 1,
        status: 0,
        text: null,
        remind: 0,
        remind_at: null,
        remind_text: null,
        deadline: null,
      },
    };
  },
  methods: {
    getModerator(manager_id) {
      var moderator = this.moderators.find((el) => el.user_id == manager_id);
      if (moderator) {
        return moderator.last_name + " " + moderator.name;
      }
    },
    postTask() {
      this.$http
        .post("admin/users/task-add?user_id=" + this.user_id, this.model)
        .then((response) => {
          this.model = JSON.parse(JSON.stringify(this.initModel));
          this.tasks.unshift(response.data);
          // JSON responses are automatically parsed.
          this.$snotify.success("Успешно!", "Задание добавлено!", {
            timeout: 500,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            position: "rightTop",
          });
        })
        .catch((e) => {
          this.$snotify.warning(e, "Возникла ошибка!", {
            timeout: 500,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            position: "rightTop",
          });
        });
    },
  },
};
</script>
